module.exports = __webpack_public_path__ + "static/media/08_hero_desktop.17d0dd87.jpg";